import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from "@material-ui/core/ListItemText";
// import InboxIcon from '@material-ui/icons/MoveToInbox';
// import MailIcon from '@material-ui/icons/Mail';
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  list: {
    width: 250,
    backgroundColor: "#FF9602",
    height: "100%",
  },
  fullList: {
    width: "auto",
  },
});

export default function TemporaryDrawer({ draweropen, setDrawerOpen }) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerOpen(open);
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem button>
          <ListItemText>
            <a href="#" style={{ color: "white", textDecoration: "none" }}>
              Home{" "}
            </a>
          </ListItemText>
        </ListItem>
        <Divider />
        {/* <ListItem button>
          <a
            href="#specification"
            style={{ color: "white", textDecoration: "none" }}
          >
            <ListItemText> Apply for IDO</ListItemText>
          </a>
        </ListItem> */}
        {/* <Divider /> */}
        {/* <ListItem button>
          <ListItemText>
            <a
              href="#distribution"
              style={{ color: "white", textDecoration: "none" }}
            >
              White paper
            </a>
          </ListItemText>
        </ListItem> */}
        {/* <Divider /> */}
      </List>
    </div>
  );

  return (
    <div>
      <React.Fragment key={"left"}>
        <Drawer
          anchor={"left"}
          open={draweropen}
          onClose={toggleDrawer("left", false)}
        >
          {list("left")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
